import styled from 'styled-components';

const SlideWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 600px;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    flex-direction: column;
    height: 800px;
  }
`;

const DoctorImage = styled.img`
  width: 40%;
  object-fit: cover;

  @media (max-width: 768px) {
    width: 100%;
    height: 360px;
  }
`;

const Info = styled.div`
  width: 60%;
  padding: 24px;
  background: #f9fbfd;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Name = styled.h2`
  margin: 0 0 8px;
  font-size: 24px;
`;

const Specialty = styled.h4`
  margin: 0 0 12px;
  color: #3498db;
`;

const GoldM = styled.h4`
  margin: 0 0 12px;
  color:rgb(235, 208, 68);
`;

const Description = styled.p`
  margin: 0;
  font-size: 16px;
  color: #555;
`;

const DoctorSlide = ({ doctor }) => (
  <SlideWrapper>
    <DoctorImage src={doctor.image} alt={doctor.name} />
    <Info>
      <Name>{doctor.name}</Name>
      <Specialty>{doctor.specialty}</Specialty>
      <GoldM>{doctor.goldm}</GoldM>
      <Description>{doctor.description}</Description>
    </Info>
  </SlideWrapper>
);

export default DoctorSlide;
